import React from 'react';
import {useNavigate} from "react-router";

import PrevIcon from '@/icons/prev-fat-icon.svg';
import {BadgeTemplate} from "@/components/templates/";
import {Button} from "@/components/atoms/";
import SuccessIcon from '@/icons/success-icon.svg?react';

import s from './queue-info.module.scss';

interface QueueInfoPageProps {
    children?: React.ReactNode;
};


const getTimeLeftText = (time) => {
    if (!time) return '';
    if (time <= 60000) return ' in less than a minute';

    const showTime = new Date(Date.now() + time);

    return ` at ${showTime.getHours()}:${showTime.getMinutes()}(in ${ Math.ceil(time / 60000) } minutes)`;
}


export const BadgeQueueInfoPage: React.FC<QueueInfoPageProps> = (props) => {
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(typeof window === 'undefined' ? {} : window.location.search);
    const waitingTime = urlParams.get('waiting-time') ? Number.parseInt(urlParams.get('waiting-time')!) :  null;

    return (
        <BadgeTemplate className={s['success-page']}>
            <div className={s['success-page__text-container']}>
                <img src={SuccessIcon} style={{margin: '0 auto 2rem'}} />
                <h1 style={{margin: '0 0 .5rem'}}>Success!</h1>
                <h4>Check out your name on <strong>the Badge Display</strong>{getTimeLeftText(waitingTime)}</h4>
                <Button
                    onClick={() => navigate('/badge/home')}
                    style={{margin: '1rem auto'}}
                    variant={'secondary'}
                    start={<img src={PrevIcon} />}
                >
                    Go back
                </Button>
            </div>
            {props.children}
        </BadgeTemplate>
    );
};
